module.exports = __webpack_public_path__ + "static/media/11.ee8e5a77.jpg";